module.exports = __webpack_public_path__ + "static/media/scale-graphic.f65dc8d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/result-page-images/scale-graphic.png
// module id = 353
// module chunks = 0